// Package imports:
import React, { useState } from 'react'
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import ScrollLock from 'react-scrolllock';
// Component imports:
import Icon from '../CustomIcon/CustomIcon';
import Logo from '../Logo/Logo';
// Type imports:
import { IUserInfo } from '../../../types/Types';

interface IOwnProps {
    userInfo: IUserInfo
}

const LoggedIn: React.FC<IOwnProps> = ({
    userInfo
}) => {
    // Toggles if menu is open for mobile only.
    const [ menuOpen, setMenuOpen] = useState(false)

    const handleMenuOpen = () => {
        // Only applies to mobile.
        if(window.innerWidth >= 1024) return;
        setMenuOpen(!menuOpen)
    }

    const logoutClicked = () => {
        setMenuOpen(false)
    }

    return (
        <div className="KCL_logged-in">
            <button onClick={handleMenuOpen}>
                <Icon type="profile" />

                <span className='username'>{userInfo.name}</span>

                <i className="icon">
                    <Icon type="dropdown-arrow" />
                </i>
            </button>

            <ScrollLock isActive={menuOpen}>
                <div className={cx('nav-access__dropdown', {'is-active': menuOpen})}>
                    <div className="nav-access__top">
                        <Logo />

                        <button
                            type="button"
                            className={cx('nav-trigger', {'is-active': menuOpen})}
                            onClick={() => setMenuOpen(!menuOpen)}
                        >
                            <span className="nav__icon">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                        </button>
                    </div>

                    <div className="nav-access__menu">
                        <ul>
                            <li className="nav-access__name">
                                <span>{userInfo.name}</span>
                            </li>
                            <li>
                                <a href="/Min-Kelda/Keyptar-Skyrslur">Keyptar skýrslur</a>
                            </li>
                            {
                            userInfo.isSubscriber && 
                                <li>
                                    <a href="/Min-Kelda/Voktun">Vöktun</a>
                                </li>
                            }
                            {
                            userInfo.isAdmin && 
                                <li>
                                    <a href="/Min-Kelda/Reikningar">Reikningar</a>
                                </li>
                            }
                            <li>
                                <a href="/Min-Kelda/Stillingar">Stillingar</a>
                            </li>
                            <li>
                                <a onClick={logoutClicked} href='/Utskraning'>
                                    <span className="icon"><FontAwesomeIcon icon={faSignOutAlt}/></span>
                                    Útskrá
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </ScrollLock>
        </div>
    );
}

export default LoggedIn;